import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { CookieAcceptService } from '../cookie-accept.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-cookie-prompt',
  templateUrl: './cookie-prompt.component.html',
  styleUrls: ['./cookie-prompt.component.scss'],
})
export class CookiePromptComponent {
  public companySlug$: Observable<string | undefined>;
  constructor(
    public translate: TranslateService,
    public dialogRef: MatDialogRef<CookiePromptComponent>,
    public cookieAcceptService: CookieAcceptService,
  ) {
    this.companySlug$ = cookieAcceptService.companySlug$;
  }
}
